/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_Give_2Inputs */

const en_cp_lead_give_2 = /** @type {(inputs: Cp_Lead_Give_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 class, club or community you connect through the form`)
};

const id_cp_lead_give_2 = /** @type {(inputs: Cp_Lead_Give_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 kelas, himpunan, atau komunitas yang kamu hubungkan lewat formulir`)
};

/**
* | output |
* | --- |
* | "1 class, club or community you connect through the form" |
*
* @param {Cp_Lead_Give_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_give_2 = /** @type {((inputs?: Cp_Lead_Give_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_Give_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_give_2(inputs)
	return en_cp_lead_give_2(inputs)
});